import { createContext, useContext } from 'react'

/*
  The signed-in business's trade, for the handful of places that phrase something in the
  owner's language rather than in general terms.

  A context rather than a prop, because the two ask boxes sit at different depths under
  different parents and neither of the chains between them has any other reason to know
  what a trade is. Threading a string through six components that ignore it is how those
  components end up taking a dozen props each.

  Null until the account resolves, and null for anything that reads it outside the signed-in
  tree, which is why every consumer has to have a sensible answer for null.
*/
export const TradeContext = createContext<string | null>(null)

export const useTrade = () => useContext(TradeContext)
